// extracted by mini-css-extract-plugin
module.exports = {"container":"QueryParamMessage_container__qZWgn","link":"QueryParamMessage_link__apDAP"};